import { render } from "./option.vue?vue&type=template&id=062a06af&ts=true"
import script from "./option.vue?vue&type=script&lang=ts"
export * from "./option.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__